import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

const FormGroup = ({ children }) => <Box sx={{ mb: 2 }}>{children}</Box>;

const ZendeskConnectForm = ({ onSubmit, guideMode, savedFormValues }) => {
  const [apiKey, setApiKey] = useState("");
  const [email, setEmail] = useState("");
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  const [showApiKey, setShowApiKey] = useState(false);

  // Load saved form values when provided (after failed submission)
  useEffect(() => {
    if (savedFormValues?.credentials) {
      const { api_key, email, url } = savedFormValues.credentials;
      setApiKey(api_key || "");
      setEmail(email || "");
      setUrl(url || "");
    }
  }, [savedFormValues]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Basic validation
    if (!apiKey) {
      setError("API Key is required");
      return;
    }
    if (!email) {
      setError("Email is required");
      return;
    }
    if (!url) {
      setError("Zendesk URL is required");
      return;
    }

    // Submit the form data
    onSubmit({
      credentials: {
        api_key: apiKey,
        email: email,
        url: url,
      },
    });
  };

  const handleClickShowApiKey = () => {
    setShowApiKey(!showApiKey);
  };

  const handleMouseDownShowApiKey = (event) => {
    event.preventDefault();
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <FormGroup>
        <Typography variant="subtitle1">Zendesk URL</Typography>
        <TextField
          placeholder="Your Zendesk URL (e.g., https://yourcompany.zendesk.com)"
          fullWidth
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          disabled={guideMode}
        />
      </FormGroup>
      <FormGroup>
        <Typography variant="subtitle1">Email</Typography>
        <TextField
          placeholder="Email address associated with the API token"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={guideMode}
        />
      </FormGroup>
      <FormGroup>
        <Typography variant="subtitle1">API Key</Typography>
        <TextField
          placeholder="Your Zendesk API key"
          fullWidth
          type={showApiKey ? "text" : "password"}
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          disabled={guideMode}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle api key visibility"
                  onClick={handleClickShowApiKey}
                  onMouseDown={handleMouseDownShowApiKey}
                >
                  {showApiKey ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </FormGroup>
      {error && (
        <Typography color="error" variant="body2" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}

      <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
        <PrimaryButton type="submit" disabled={guideMode}>
          Connect
        </PrimaryButton>
      </Box>
    </Box>
  );
};

export default ZendeskConnectForm;
